package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AssetQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    kind: String,
    currency: String,
    value_: Long?,
    purchase_price: Long?,
    acquired_date: String?,
    valued_at: String?,
    note: String?,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(158_065_875, arrayOf("asset"), driver, "Asset.sq", "selectAll",
      "SELECT asset.id, asset.name, asset.kind, asset.currency, asset.value, asset.purchase_price, asset.acquired_date, asset.valued_at, asset.note, asset.archived, asset.order_index, asset.created_at, asset.updated_at, asset.is_deleted, asset.deleted_at, asset.synced_at FROM asset WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4),
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectAll(): Query<Asset> = selectAll { id, name, kind, currency, value_,
      purchase_price, acquired_date, valued_at, note, archived, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Asset(
      id,
      name,
      kind,
      currency,
      value_,
      purchase_price,
      acquired_date,
      valued_at,
      note,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    kind: String,
    currency: String,
    value_: Long?,
    purchase_price: Long?,
    acquired_date: String?,
    valued_at: String?,
    note: String?,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_580_141_188, arrayOf("asset"), driver, "Asset.sq", "selectDirty",
      "SELECT asset.id, asset.name, asset.kind, asset.currency, asset.value, asset.purchase_price, asset.acquired_date, asset.valued_at, asset.note, asset.archived, asset.order_index, asset.created_at, asset.updated_at, asset.is_deleted, asset.deleted_at, asset.synced_at FROM asset WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4),
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectDirty(): Query<Asset> = selectDirty { id, name, kind, currency, value_,
      purchase_price, acquired_date, valued_at, note, archived, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Asset(
      id,
      name,
      kind,
      currency,
      value_,
      purchase_price,
      acquired_date,
      valued_at,
      note,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    kind: String,
    currency: String,
    value_: Long?,
    purchase_price: Long?,
    acquired_date: String?,
    valued_at: String?,
    note: String?,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4),
      cursor.getLong(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14),
      cursor.getLong(15)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Asset> = selectByIdAnyState(id) { id_, name,
      kind, currency, value_, purchase_price, acquired_date, valued_at, note, archived, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Asset(
      id_,
      name,
      kind,
      currency,
      value_,
      purchase_price,
      acquired_date,
      valued_at,
      note,
      archived,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    kind: String,
    currency: String,
    value_: Long?,
    purchase_price: Long?,
    acquired_date: String?,
    valued_at: String?,
    note: String?,
    archived: Long,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_462_221_739, """
        |INSERT INTO asset(id, name, kind, currency, value, purchase_price, acquired_date, valued_at, note, archived, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 13) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, kind)
          bindString(3, currency)
          bindLong(4, value_)
          bindLong(5, purchase_price)
          bindString(6, acquired_date)
          bindString(7, valued_at)
          bindString(8, note)
          bindLong(9, archived)
          bindLong(10, order_index)
          bindLong(11, created_at)
          bindLong(12, updated_at)
        }
    notifyQueries(1_462_221_739) { emit ->
      emit("asset")
    }
  }

  public fun update(
    name: String,
    kind: String,
    currency: String,
    value_: Long?,
    purchase_price: Long?,
    acquired_date: String?,
    valued_at: String?,
    note: String?,
    archived: Long,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_807_167_931, """
        |UPDATE asset
        |SET name = ?, kind = ?, currency = ?, value = ?, purchase_price = ?, acquired_date = ?, valued_at = ?, note = ?, archived = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 12) {
          bindString(0, name)
          bindString(1, kind)
          bindString(2, currency)
          bindLong(3, value_)
          bindLong(4, purchase_price)
          bindString(5, acquired_date)
          bindString(6, valued_at)
          bindString(7, note)
          bindLong(8, archived)
          bindLong(9, order_index)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(1_807_167_931) { emit ->
      emit("asset")
    }
  }

  public fun updateValue(
    value_: Long?,
    valued_at: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(807_619_702,
        """UPDATE asset SET value = ?, valued_at = ?, updated_at = ? WHERE id = ?""", 4) {
          bindLong(0, value_)
          bindString(1, valued_at)
          bindLong(2, updated_at)
          bindString(3, id)
        }
    notifyQueries(807_619_702) { emit ->
      emit("asset")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_666_010_727,
        """UPDATE asset SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_666_010_727) { emit ->
      emit("asset")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_519_581_148,
        """UPDATE asset SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_519_581_148) { emit ->
      emit("asset")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_426_062_951,
        """UPDATE asset SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_426_062_951) { emit ->
      emit("asset")
    }
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("asset", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("asset", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(714_639_621,
        """SELECT asset.id, asset.name, asset.kind, asset.currency, asset.value, asset.purchase_price, asset.acquired_date, asset.valued_at, asset.note, asset.archived, asset.order_index, asset.created_at, asset.updated_at, asset.is_deleted, asset.deleted_at, asset.synced_at FROM asset WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Asset.sq:selectByIdAnyState"
  }
}
